import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const OnboardingExit = ({ backTo, backLabel = "Back" }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const cancel = async () => {
    setBusy(true);
    setError("");
    try {
      await api.delete("/account/signup");
      await logout().catch(() => {});
      window.location.replace("/register");
    } catch (e) {
      setError(apiError(e));
      setBusy(false);
    }
  };

  return (
    <div className="space-y-3" data-testid="onboarding-exit">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <button
          type="button"
          onClick={() => (backTo ? navigate(backTo) : navigate(-1))}
          className="flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-brand"
          data-testid="onboarding-back"
        >
          <ArrowLeft className="h-4 w-4" /> {backLabel}
        </button>
        <button
          type="button"
          onClick={() => setConfirm(true)}
          className="text-sm font-medium text-red-600 hover:underline"
          data-testid="cancel-signup-button"
        >
          Cancel sign-up
        </button>
      </div>
      {confirm && (
        <div className="rounded-xl border border-red-200 bg-red-50 p-4" data-testid="cancel-signup-confirm">
          <p className="text-sm text-red-800">
            This deletes your unfinished account for good. You can register again with the same email
            straight away.
          </p>
          {error && <p className="mt-2 text-sm text-red-700" data-testid="cancel-signup-error">{error}</p>}
          <div className="mt-4 flex flex-wrap gap-3">
            <button
              type="button"
              onClick={cancel}
              disabled={busy}
              className="rounded-lg bg-red-600 px-3.5 py-2 text-sm font-medium text-white disabled:opacity-50"
              data-testid="cancel-signup-confirm-button"
            >
              {busy ? "Cancelling…" : "Yes, cancel and delete"}
            </button>
            <button type="button" onClick={() => setConfirm(false)} className="btn-ghost" data-testid="cancel-signup-keep">
              Keep going
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
